import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"

const dataProviderName = 'persons/person';
const model = 'persons/person';
const wizardName = 'Car Configuration Access Management';
const wizardObject = 'Car';
const wizardAction = 'configuratorManagementMulti';

const ConfiguratorManagementMulti = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);

    const [drawable, setDrawable] = useState(false);
    const { doAction, getOne, item, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.inverseRelation, params?.detailStack?.stack);

    const person = discover('person');
    const [segmentList, setSegmentList] = useState();
    const { items: segments, loadAll: loadAllSegments } = useDataProvider('infocar/getAvailableSegments');

    useEffect(() => {
        loadAllSegments().then((segments) => {
            let sl = segments.items.map((segment) => {
                return {
                    "label": segment.Descrizione,
                    "value": segment.Descrizione,//segment.Codice
                }
            });
            setSegmentList(sl);
            setDrawable(true);
        });
    }, []);

    let detailConfig = {
        "tabs": [
            {
                "name": "configuration",
                "fieldsets": [
                    {
                        "name": "configuration",
                        "fields": {
                            "configuration": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "fleetConfigurationActive": {
                                "type": "select",
                                "required": true,
                                "options": [
                                    {
                                        "label": "true",
                                        "value": "true"
                                    },
                                    {
                                        "label": "false",
                                        "value": "false"
                                    }
                                ],
                                "className": "col-4",
                                "icon": "faToggle"
                            },
                            "fleetConfigurationLinkValid_at": {
                                "type": "date",
                                "required": true,
                                "className": "col-4",
                                "icon": "faCalendarHeart"
                            },
                            "fleetConfigurationLinkExpire_at": {
                                "type": "date",
                                "required": true,
                                "className": "col-4",
                                "icon": "faCalendarXmark"
                            }
                        }
                    }
                ]
            }
        ],
        "validation": []
    };

    let values = {
        "ids": params?.person?._id,
        "email": params?.person?.email,
        "segment": params?.person?.employment?.segment,
    };


    const persons = params.personIds.map(async (id) => {
        const person = getOne(id);
        // addPersonDetailConfig(person._id);
        // addPersonValues(person);
        return person;
    })

    const addPersonValues = (person) => {
        values[person._id + ".id"] = person._id;
        values[person._id + ".name"] = person.firstname + " " + person.lastname;
        values[person._id + ".segment"] = person._related_employment_segment;
        values[person._id + ".email"] = person._related_employment_segment;
    }

    const addPersonDetailConfig = (id) => {
        detailConfig.tabs[0].fieldsets.push({
            "name": "configuration",
            "fields": {
                [id + ".name"]: {
                    "type": "select",
                    "required": true,
                    "options": segmentList,
                    "className": "col-3",
                    "icon": "faCircleX"
                },
                [id + ".segment"]: {
                    "type": "select",
                    "required": true,
                    "options": segmentList,
                    "className": "col-3",
                    "icon": "faCircleX"
                },
                [id + ".fleetConfigurationQuantityUnlimited"]: {
                    "type": "select",
                    "required": true,
                    "options": [
                        {
                            "label": "true",
                            "value": "true"
                        },
                        {
                            "label": "false",
                            "value": "false"
                        }
                    ],
                    "className": "col-3",
                    "icon": "faToggle"
                },
                [id + ".fleetConfigurationLink"]: {
                    "type": "text",
                    "required": true,
                    "readonly": true,
                    "className": "col-3",
                    "icon": "faGlobe"
                },
                [id + ".fleetDriverCode"]: {
                    "type": "hidden",
                },
                [id + ".email"]: {
                    "type": "hidden",
                },
                [id + ".id"]: {
                    "type": "hidden",
                },
            }
        })
    }

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])

    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <>
                <DetailComponent
                    values={values}
                    modelName={model.split('/')[1]}
                    detailConfig={detailConfig}
                    dataProviderName={dataProviderName}
                    onEditing={setEditing}
                    save={handleSave}
                    saving={saving}
                    errors={errors}
                    errorMessage={(params?.person?.employment?.legalEntity?.configurator !== 'infocarfleet') ? t('LegalEntity not allowed to configure') : errorMessage}
                    title={t(wizardName)}
                    canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
                    header={
                        <InfoHeader
                            view="wizard"
                            title={t(wizardName)}
                            subtitle={t('Manage the access to Car Configurator for {{firstname}} {{lastname}}', { wizardObject: wizardObject, firstname: params?.person?.firstname, lastname: params?.person?.lastname })}
                        />
                    }
                    {...params}
                />
            </>
    )
}

export default ConfiguratorManagementMulti;